<template lang="pug">
div(v-if="item" class=" tw-rounded-md tw-border tw-border-solid tw-border-gray-lighten-2 tw-my-2 tw-p-2 tw-bg-white ")
  v-row(no-gutters align="start" justify="space-between" class=" tw-py-0 tw-my-0")
    v-col(class="pr-0 md:tw-text-left ")
      v-row(no-gutters)
        v-col
          div(class=" tw-font-medium tw-text-blueGray-darken-2 tw-text-base")
            router-link(class="tw-font-medium text-link" :to="{ name: 'opportunityDetail', params: { id: item.id } }") {{ item.name }}
    //- v-col(cols="auto" class="tw-py-0")
    //-   v-row(no-gutters class="")
    //-     v-col(class=" tw-m-0")
    //-       v-menu(bottom left rounded="xl" nudge-bottom="40")
    //-         template(v-slot:activator="{ on, attrs }")
    //-           v-btn(
    //-             :ripple="false"
    //-             depressed
    //-             v-on="on"
    //-             v-bind="attrs"
    //-             width="10px"
    //-             max-width="10"
    //-             min-width="10"
    //-             min-height="10"
    //-             max-height="30"
    //-             class="tw-border-gray-lighten-1 tw-p-0 tw-m-0"
    //-           )
    //-             v-icon(color="blue-grey darken-1 tw-p-0 tw-m-0") mdi-dots-horizontal
  v-row(no-gutters align="start" class="tw-pt-4")
    v-col
      v-row(no-gutters)
        v-col
          v-icon(color=" blue-grey lighten-3") mdi-order-bool-ascending-variant
          span(class="tw-pl-1 tw-font-medium tw-text-blueGray-lighten-1 tw-capitalize") {{ $t('Opportunities.Common.progress') }}
        v-col(class=" tw-text-right")
          span(class=" tw-font-semibold tw-text-blueGray-lighten-1") {{ item.tasks_completed }} / {{ item.tasks_total }}
  v-row(no-gutters class="tw-pt-1")
    v-col
      v-progress-linear(
        rounded
        height="6"
        :color="progress.color"
        background-color="blue-grey lighten-5"
        :value="progress.value"
      )
  v-row(no-gutters align="center" class="tw-pt-3")
    v-col
      div(
        v-if="item.stage != 4"
        class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-blueGray-lighten-5 tw-text-blueGray-lighten-2"
      )
        span {{ this.$moment(item.expected_close_date).format('DD MMM YYYY') }}
      div(
        v-if="item.stage == 4 && item.closed_state == 1"
        class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-green-lighten-5 tw-text-green-lighten-2"
      )
        span Won!!
      div(
        v-if="item.stage == 4 && item.closed_state == 2"
        class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-pink-lighten-5 tw-text-pink-lighten-2"
      )
        span Lost
      div(
        v-if="item.stage == 4 && !item.closed_state"
        class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-blueGray-lighten-5 tw-text-blueGray-lighten-2"
      )
        span Closed

    v-col(class="tw-text-right")
      span(
        :class="item.stage == 4 && item.closed_state == 2 ? 'tw-text-pink-lighten-2' : 'green--text'"
        class="tw-text-sm  tw-font-bold tw-px-3"
      ) {{ this.$formatters.formatValue(item.amount) }}
</template>
<script>
export default {
  props: ['item'],
  computed: {
    progress: function () {
      let value = (this.item.tasks_completed / this.item.tasks_total) * 100;
      if (!value) {
        value = 0;
      }
      let progress = {};
      progress.value = value;
      switch (true) {
        case value <= 25:
          progress.color = '#FF808B';
          break;

        case value <= 50:
          progress.color = '#F4BE5E';
          break;

        case value <= 75:
          progress.color = '#5E81F4';
          break;

        case value <= 100:
          progress.color = '#7CE7AC';
          break;

        default:
          break;
      }
      return progress;
    },
  },
};
</script>
